class ShareMenu extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', this._onClick);
    }

    /**
     * @param {MouseEvent & {
     *     target: Element;
     * }} event
     */
    async _onClick(event) {
        const lastItem = event.target.closest('.menu__item:last-child');

        if (lastItem) {
            event.preventDefault();
            await navigator.clipboard?.writeText(lastItem.getAttribute('href'));
        }
    }
}

customElements.define('share-menu', ShareMenu);
export default ShareMenu;
